import Vue from 'vue'
import VueRouter from 'vue-router'

import userStore from '@/stores/UserStore'

import PrivacyPolicies from '@/components/Pages/PrivacyPolicies'
import Login from '@/components/Pages/Login'
import Register from '@/components/Pages/Register'
import ResetPassRequest from '@/components/Pages/ResetPassRequest'
import ResetPass from '@/components/Pages/ResetPass'
import FirstTimePass from '@/components/Pages/FirstTimePass'
import NewUserPassword from '@/components/Pages/NewUserPassword'

import Dashboard from '@/components/Views/Dashboard/Dashboard'
import Users from '@/components/Views/Users'
import CRM from '@/components/Views/CRM'
import ArchivedCRM from '@/components/Views/Archived/ArchivedCRM'
import ArchivedPreprojects from '@/components/Views/Archived/ArchivedPreprojects'
import Conversation from '@/components/Views/CRM/Conversation'
import CompanyConcepts from '@/components/Views/CRM/CompanyConcepts'

import Companies from '@/components/Views/Companies'
import Roles from '@/components/Views/Companies/Roles'
import ProjectTypes from '@/components/Views/Companies/ProjectTypes'
import ProjectDestinies from '@/components/Views/Companies/ProjectDestinies'
import CompanyPrefixes from '@/components/Views/Companies/CompanyPrefixes'
import CompanyUnarchiveValues from '@/components/Views/Companies/CompanyUnarchiveValues'
import ProjectTypesStages from '@/components/Views/Companies/ProjectTypesStages'

import VTMap from '@/components/Views/VTMap'

import Schedules from '@/components/Views/Schedules'

import Policies from '@/components/Views/Policies'
import UserDetailPolicies from '@/components/Views/Policies/UserDetail'

import Clients from '@/components/Views/Clients'
import ClientsCompanyAprovals from '@/components/Views/Clients/ClientsCompanyAprovals'
import ClientDetail from '@/components/Views/Clients/ClientDetail'
import MyClientDetail from '@/components/Views/Clients/MyClientDetail'

import PreProjects from '@/components/Views/PreProjects'
import PreProject from '@/components/Views/PreProjects/PreProject'

import Chat from '@/components/Views/Chat'

import CompanyPlanningConfig from '@/components/Views/Projects/CompanyPlanningConfig'
import ProjectPlanningConfig from '@/components/Views/Projects/ProjectPlanningConfig'
import BudgetContractSerialsTable from '@/components/Views/Budgets/BudgetContractSerialsTable'
// import CompanyPlanningConfigB from '@/components/Views/Projects/CompanyPlanningConfigB'

import ProjectCostBreakdown from '@/components/Views/Projects/CostBreakdownTable'
import CompanyCostItemConfig from '@/components/Views/Companies/CompanyCostItemConfig'

import ContractsConfig from '@/components/Views/Companies/ContractsConfig'
import ContractDetail from '@/components/Views/Contracts/ContractDetail'
import SubcontractDetail from '@/components/Views/Contracts/SubcontractDetail'
import ClientContract from '@/components/Views/Clients/Parts/Contracts/ClientContract'
import ContractAddendumDetail from '@/components/Views/Contracts/ContractAddendumDetail'
import Contracts from '@/components/Views/Contracts'
import Subcontracts from '@/components/Views/Contracts/indexSubcontratos'
import SubcontractsContractor from '@/components/Views/Contracts/indexSubcontractsContractor'

import Budgets from '@/components/Views/Budgets'
import BudgetDetail from '@/components/Views/Budgets/BudgetDetail'

import Reports from '@/components/Views/Reports'
import ReportDetail from '@/components/Views/Reports/ReportDetail'
import ReportBudgetDetail from '@/components/Views/Reports/ReportBudgetDetail'

import UserRequests from '@/components/Views/UserRequests'

import OnlyOfficeFullEditor from '@/components/Pages/OnlyOfficeFullEditor'

import OnlyContent from '@/components/Helpers/Components/OnlyContent'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history', // https://router.vuejs.org/api/#mode
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes(){
	return [
    {
      path: '/policies',
      name: 'PrivacyPolicies',
      meta: { label: 'PrivacyPolicies'},
      component: PrivacyPolicies
    },
    {
      path: '/newuser',
      name: 'NewUserPassword',
      meta: { label: 'NewUserPassword'},
      component: NewUserPassword
    },
    {
      path: '/login',
      name: 'Login',
      meta: { label: 'Login'},
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      meta: { label: 'Register'},
      component: Register
    },
    {
      path: '/reset-pass-request',
      name: 'ResetPassRequest',
      meta: { label: 'ResetPassRequest'},
      component: ResetPassRequest
    },
    {
      path: '/reset-pass/:token',
      name: 'ResetPass',
      meta: { label: 'ResetPass'},
      component: ResetPass
    },
    {
      path: '/set-new-pass/:token',
      name: 'FirstTimePass',
      meta: { label: 'FirstTimePass'},
      component: FirstTimePass
    },
    {
      path: '/',
      name: 'Dashboard',
      meta: { label: 'Panel de Control'},
      component: Dashboard
    },
    {
      path: '/users',
      name: 'Users',
      meta: { label: 'Listado de Usuarios', requiredPermissions: ['view_users'] },
      component: Users
    },
    {
      path: '/crm',
      name: 'CRM',
      meta: { label: 'CRM / Solicitudes', requiredPermissions: ['view_crm'] },
      component: CRM
    },
    {
      path: '/archive/crm',
      name: 'ArchivedCRM',
      meta: { label: 'CRM / Solicitudes (Archivadas)', requiredPermissions: ['view_crm'] },
      component: ArchivedCRM
    },
    {
      path: '/archive/preprojects',
      name: 'ArchivedPreprojects',
      meta: { label: 'Gestión Antecedentes (Archivados)', requiredPermissions: ['view_preprojects'] },
      component: ArchivedPreprojects
    },
    {
      path: '/crm/conversation/:id',
      name: 'Conversation',
      meta: { label: 'Ficha Visita Técnica', requiredPermissions: ['view_crm'] },
      component: Conversation
    },
    {
      path: '/crm/concepts',
      name: 'CompanyConcepts',
      meta: { label: 'Conceptos de la empresa', requiredPermissions: ['view_company_concepts'] },
      component: CompanyConcepts
    },
    {
      path: '/companies',
      name: 'Companies',
      meta: { label: 'Empresas' },
      component: Companies
    },
    {
      path: '/company-roles',
      name: 'Roles',
      meta: { label: 'Roles Empresa', requiredPermissions: ['view_company_roles'] },
      component: Roles
    },
    {
      path: '/project-types',
      name: 'ProjectTypes',
      meta: { label: 'Tipos de Proyecto', requiredPermissions: ['view_company_project_types'] },
      component: ProjectTypes
    },
    {
      path: '/project-destinies',
      name: 'ProjectDestinies',
      meta: { label: 'Destinos', requiredPermissions: ['view_company_project_types'] },
      component: ProjectDestinies
    },
    {
      path: '/document-prefixes',
      name: 'DocumentPrefixes',
      meta: { label: 'Prefijos de Documentos (Eliminados)', requiredPermissions: ['view_company_project_types'] },
      component: CompanyPrefixes
    },
    {
      path: '/unarchive-values',
      name: 'CompanyUnarchiveValues',
      meta: { label: 'Valores Desarchivos', requiredPermissions: ['view_company_project_types'] },
      component: CompanyUnarchiveValues
    },
    {
      path: '/project-types-stages',
      name: 'ProjectTypesStages',
      meta: { label: 'Tipos de Proyecto - Etapas', requiredPermissions: ['view_company_project_types'] },
      component: ProjectTypesStages
    },
    {
      path: '/vt-map',
      name: 'VTMap',
      meta: { label: 'Mapa Valores Visitas Técnicas', requiredPermissions: ['view_vt_maps'] },
      component: VTMap
    },
    {
      path: '/schedule',
      name: 'Schedules',
      meta: { label: 'Agenda', requiredPermissions: ['schedule_access'] },
      component: Schedules
    },
    {
      path: '/accepted_policies',
      name: 'Policies',
      meta: { label: 'Aceptación Políticas' },
      component: Policies
    },
    {
      path: '/user_policy/:user_id',
      name: 'UserDetailPolicies',
      meta: { label: 'Políticas Aceptadas Usuario', requiredPermissions: ['super_admin_rights'] },
      component: UserDetailPolicies
    },
    {
      path: '/clients',
      name: 'Clients',
      meta: { label: 'Clientes', requiredPermissions: ['view_clients'] },
      component: Clients
    },
    {
      path: '/clients-company-history',
      name: 'ClientsCompanyAprovals',
      meta: { label: 'Solicitudes Clientes Empresas', requiredPermissions: ['view_clients'] },
      component: ClientsCompanyAprovals
    },
    {
      path: '/clients/:id',
      name: 'Client',
      meta: { label: 'Cliente', requiredPermissions: ['view_clients'] },
      component: ClientDetail
    },
    {
      path: '/client',
      name: 'ClientDetail',
      meta: { label: 'Cliente', requiredPermissions: ['client_capabilities'] },
      component: MyClientDetail
    },
    {
      path: '/preprojects',
      name: 'PreProjects',
      meta: { label: 'Pre Proyectos', subtitle: 'Gestión Antecedentes', requiredPermissions: ['view_preprojects'] },
      component: PreProjects
    },
    {
      path: '/preprojects/:id',
      name: 'PreProject',
      meta: { label: 'Detalle Pre Proyecto', subtitle: 'Gestión Antecedentes', requiredPermissions: ['view_preprojects'] },
      component: PreProject
    },
    {
      path: '/projects/planning/config',
      name: 'CompanyPlanningConfig',
      meta: { label: 'Configuración General Programación Proyectos', requiredPermissions: ['company_project_planning'] },
      component: CompanyPlanningConfig
    },
    {
      path: '/projects/planning',
      name: 'ProjectPlanningConfig',
      meta: { label: 'Programación Proyectos', requiredPermissions: ['company_project_planning'] },
      component: ProjectPlanningConfig
    },
    {
      path: '/projects/:id/cost-breakdown',
      name: 'ProjectCostBreakdown',
      meta: { label: 'Tabla de Costos Proyecto' },
      component: ProjectCostBreakdown
    },
    {
      path: '/companies/base-cost-config',
      name: 'CompanyCostItemConfig',
      meta: { label: 'Configuración de Costos Base' },
      component: CompanyCostItemConfig
    },
    {
      path: '/contracts/config',
      name: 'ContractsConfig',
      meta: { label: 'Configuración Secciones Contratos / Subcontratos', requiredPermissions: ['edit_contracts'] },
      component: ContractsConfig
    },
    {
      path: '/contracts/detail',
      name: 'ContractDetail',
      meta: { label: 'Detalle Contrato', requiredPermissions: ['view_contracts'] },
      component: ContractDetail
    },
    {
      path: '/contracts/subcontract-detail',
      name: 'SubcontractDetail',
      meta: { label: 'Detalle Subcontrato', requiredPermissions: ['view_contracts'] },
      component: SubcontractDetail
    },
    {
      path: '/contracts/subcontract-contractor',
      name: 'SubcontractContractor',
      meta: { label: 'Detalle Subcontrato', requiredPermissions: ['subcontractor'] },
      component: ClientContract
    },
    {
      path: '/contracts/addendum_detail',
      name: 'ContractAddendumDetail',
      meta: { label: 'Detalle Anexo de Contrato', requiredPermissions: ['view_contracts'] },
      component: ContractAddendumDetail
    },
    {
      path: '/subcontracts',
      name: 'Subcontracts',
      meta: { label: 'Subcontratos', requiredPermissions: ['view_contracts'] },
      component: Subcontracts
    },
    {
      path: '/subcontracts-contractor',
      name: 'SubcontractsContractor',
      meta: { label: 'Subcontratos', requiredPermissions: ['subcontractor'] },
      component: SubcontractsContractor
    },
    {
      path: '/contracts',
      name: 'Contracts',
      meta: { label: 'Contratos', requiredPermissions: ['view_contracts'] },
      component: Contracts
    },
    {
      path: '/budgets',
      name: 'Budgets',
      meta: { label: 'Presupuestos', requiredPermissions: ['view_budgets'] },
      component: Budgets
    },
    {
      path: '/budgets/detail',
      name: 'BudgetDetail',
      meta: { label: 'Presupuesto', requiredPermissions: ['view_budgets'] },
      component: BudgetDetail
    },
    {
      path: '/projects-serials',
      name: 'BudgetContractSerialsTable',
      meta: { label: 'Tabla Correlativos' },
      component: BudgetContractSerialsTable
    },
    {
      path: '/reports',
      name: 'Reports',
      meta: { label: 'Informes', requiredPermissions: ['view_reports'] },
      component: Reports
    },
    {
      path: '/reports/detail',
      name: 'ReportDetail',
      meta: { label: 'Informe', requiredPermissions: ['view_reports'] },
      component: ReportDetail
    },
    {
      path: '/unarchive/detail',
      name: 'ReportBudgetDetail',
      meta: { label: 'Presupuesto Desarchivo', requiredPermissions: ['view_reports'] },
      component: ReportBudgetDetail
    },
    {
      path: '/user_requests',
      name: 'UserRequests',
      meta: { label: 'Solicitudes', requiredPermissions: ['view_clients'] },
      component: UserRequests
    },
		{
      path: '/built-in-content',
      name: 'OnlyContent',
      meta: { label: 'Aux Content' },
      component: OnlyContent
    },
    // {
    //   path: '/projects/planning/config-b',
    //   name: 'CompanyPlanningConfigB',
    //   meta: { label: 'Programación General Proyectos 2' },
    //   component: CompanyPlanningConfigB
    // },
    {
      path: '/chat',
      name: 'Chat',
      meta: { label: 'Chat' },
      component: Chat
    },
    {
      path: '/document-editor/:id',
      name: 'Editor',
      meta: { label: 'Editor' },
      component: OnlyOfficeFullEditor
    },
		
	]
}

router.beforeEach((to, from, next) => {
  const requiredPermissions = to.meta.requiredPermissions || [];
	const userPermissions = userStore.state.companyPermissions

  if (to.name !== 'Login' && to.name !== 'Register' && to.name !== 'ResetPassRequest' && to.name !== 'ResetPass' && to.name !== 'NewUserPassword' && to.name !== 'PrivacyPolicies' && to.name !== 'FirstTimePass' && !userStore.state.isAuthenticated) next({ name: 'Login' })
  else if ((to.name === 'Login' || to.name === 'Register' || to.name === 'NewUserPassword') && userStore.state.isAuthenticated) next({ name: 'Dashboard' })
	else if (requiredPermissions.length > 0) {
		if(!userPermissions || userPermissions && Object.keys(userPermissions).length <= 0){
			next({ name: 'Dashboard' })
		}
		const hasPermission = requiredPermissions.every(permission =>
			userPermissions && userPermissions[permission] === true
		);

		if (!hasPermission) {
			return null
		}
		next()
	}
  else next()
})

export default router